/**
 * Copy and routing for guest "mirage" Monkey challenge (sign-up cliffhanger).
 * No server row until the user authenticates; payload is held locally then flushed.
 */

/** Estimated total match duration used to compute slip expiry (90 min + stoppage). */
export const GUEST_MONKEY_ESTIMATED_MATCH_DURATION_MS = 110 * 60 * 1_000;

/** Orphaned slip TTL — discard any pending slip older than 48 h to avoid stale queue buildup. */
export const GUEST_MONKEY_SLIP_TTL_MS = 48 * 60 * 60 * 1_000;

/** Shown on Arena after guest sends a Monkey slip (not on Create). */
export const GUEST_MONKEY_ARENA_LOGIN_DIALOG = {
  TITLE: 'Almost there',
  MESSAGE:
    'Your challenge to the Monkey is saved here. Log in or sign up to lock it in and track it in the Arena.',
  CONFIRM: 'Log in or sign up',
  CANCEL: 'Later',
} as const;

/** After sign-up / sign-in, land here before flush runs (arena shows new challenge). */
export const GUEST_MONKEY_POST_AUTH_PATH = '/app/' as const;
